export default __webpack_public_path__ + "static/media/font.0525ad1b.png";